<div class="loader-container" *ngIf="isLoading" [style.height.px]="windowHeight">
  <img src="/assets/images/loader/eyesnroad-loading-pc.gif">
  <p>{{'loading' | i18n}}...</p>
</div>
